import { Stack } from '@cad-arc';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { TabSection } from '../../../panels/entity-panels/tabs/tab-section';
import { useIntegratedEventDispositionsQuery } from '../../event-state/use-integrated-event-dispositions-query';
import { DispositionLog } from './disposition-log';

export function DispositionsTab() {
    const eventId = useWorkspacePanel().linkedEntityId;

    const {
        isInitialLoading: isEventDispositionsInitialLoading,
        data: eventDispositionsData,
    } = useIntegratedEventDispositionsQuery({ eventId });

    return (
        <EventPanelTab title="Dispositions">
            <TabBody>
                <TabSection loading={isEventDispositionsInitialLoading}>
                    <Stack spacing={4}>
                        {eventDispositionsData?.dispositions?.map((disposition) => {
                            return (
                                <DispositionLog key={disposition.id} disposition={disposition} />
                            );
                        })}
                    </Stack>
                </TabSection>
            </TabBody>
        </EventPanelTab>
    );
}
